import { Card } from 'antd';
import { forwardRef } from 'react';
import { CompWithFormProp } from '../../../constants/constants';
import { clearEmptyValues } from '../../../functions/functions';
import { DocumentPreviewMeta } from './DocumentPreviewMeta';
import { DocumentPreviewRegistration } from './DocumentPreviewRegistration';
import { DocumentPreviewSubjectData } from './DocumentPreviewSubjectData';
import Print from './Print.css';

export const DocumentPreview = forwardRef<HTMLDivElement, CompWithFormProp>(
  ({ form }, ref) => {
    const formData = clearEmptyValues(form.getFieldsValue());

    return (
      <div ref={ref}>
        <Card
          className={Print.Page}
          style={{
            margin: '12px 0',
          }}
        >
          <DocumentPreviewMeta
            studentName={formData?.registration?.student}
            metaDataDate={undefined}
          />
          <DocumentPreviewRegistration
            form={form}
            registrationData={formData?.registration}
          />
          {formData.subject && formData.registration.selectedSubject && (
            <DocumentPreviewSubjectData
              data={formData.subject ? formData.subject : {}}
              selectedSubject={formData.registration.selectedSubject}
            />
          )}
        </Card>
      </div>
    );
  },
);
